import { SxProps, Theme } from "@mui/material";

export const dividerStyles: SxProps<Theme> = (theme) => ({
    backgroundColor: theme.palette.divider,
    height: "3px",
    margin: "20px 0",
});
